﻿export interface ICenterFiveStarSurveyType {
    dash: boolean;
    dcn: boolean;
    nkr: boolean;
}
